import ServiceSuggestionBanner from './ServiceSuggestionBanner';
import SupportContactCard from './SupportContactCard';
import SupportEmptyState from './SupportEmptyState';

const UserSupportView = ({ supportData }) => {
  const practiceSupport = supportData?.practiceSupport;

  const hasMedbill = practiceSupport?.medbill_built_in_biller === true;
  const hasVom = practiceSupport?.medbill_virtual_office_manager === true;

  const hasTeamAssigned =
    practiceSupport?.consultant ||
    practiceSupport?.onboardingArchitect ||
    practiceSupport?.insideRepresentative;

  if (!hasTeamAssigned) {
    return <SupportEmptyState suggestMedbill={!hasMedbill} suggestVom={!hasVom} />;
  }

  return (
    <div className="flex w-full justify-center pb-5">
      <div className="w-full">
        <div className="grid grid-cols-3 gap-4 sm:grid-cols-1 md:grid-cols-2">
          <SupportContactCard title="Management consultant" contact={practiceSupport?.consultant} />
          <SupportContactCard
            title="Onboarding architect"
            contact={practiceSupport?.onboardingArchitect}
            className="!border-primary-200 bg-primary-50"
          />
          <SupportContactCard
            title="Inside representative"
            contact={practiceSupport?.insideRepresentative}
            className="!border-orange-dark-200 bg-orange-dark-50"
          />
        </div>

        {hasMedbill && !hasVom && <ServiceSuggestionBanner service="vom" />}
        {hasVom && !hasMedbill && <ServiceSuggestionBanner service="medbill" />}
        {!hasMedbill && !hasVom && <ServiceSuggestionBanner service="both" />}
      </div>
    </div>
  );
};

export default UserSupportView;
